import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';

const areas = [
  { name: 'Wien', text: 'Innenstadt, Außenbezirke, Sanierung, Rohbau, private Projekte.' },
  { name: 'Wien Umgebung', text: 'Schnelle Abstimmung für Baustellen rund um die Stadt.' },
  { name: 'Niederösterreich', text: 'Betontransport und Pumpeneinsatz nach projektbezogener Planung.' },
];

function AreaSection() {
  return (
    <section className="py-12 sm:py-16 md:py-28 border-y border-ink/10 bg-white/40 w-full">
      <div className="container-site mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="Einsatzgebiet"
            title="Regional schnell erreichbar."
            compact
          />
        </Reveal>

        <div className="grid md:grid-cols-3 gap-4 mt-8">
          {areas.map((area, index) => (
            <Reveal key={area.name} delay={index * 100}>
              <div className="relative p-5 rounded-card border border-ink/10 bg-white/90 shadow-card min-h-[160px] sm:min-h-[190px] overflow-hidden transition-all hover:-translate-y-1 hover:border-signal/40 hover:shadow-[0_18px_42px_rgba(13,37,46,0.12)]">
                <div className="absolute -right-8 -bottom-8 w-24 h-24 rounded-full border border-signal/15" aria-hidden="true" />
                <strong className="block text-xl sm:text-2xl font-extrabold mb-3">{area.name}</strong>
                <span className="block text-ink-soft text-sm sm:text-base">{area.text}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AreaSection;
